import { OFFER_CARD_WRAPPER } from 'Constant';
import { renderAccordion } from 'Container/OfferDisplay/helpers/renderers/accordionRenderHelper';
import { renderBasketSummary } from 'Container/OfferDisplay/helpers/renderers/basketSummaryRenderHelper';
import { renderBenefitList } from 'Container/OfferDisplay/helpers/renderers/benefitListRenderHelper';
import { renderHeadlines } from 'Container/OfferDisplay/helpers/renderers/headlinesRenderHelper';
import { renderMultiDivider } from 'Container/OfferDisplay/helpers/renderers/multiDividerRenderHelper';
import { renderOfferPrice } from 'Container/OfferDisplay/helpers/renderers/offerPriceRenderHelper';
import { renderPriceCompositions } from 'Container/OfferDisplay/helpers/renderers/priceCompositionsRenderHelper';
import { renderPriceDetailHeadlines } from 'Container/OfferDisplay/helpers/renderers/priceDetailHeadlinesRenderHelper';
import { renderTotalDiscounts } from 'Container/OfferDisplay/helpers/renderers/totalDiscountRenderHelper';
import { IOfferFromJSON } from '../../../../types';

const HTMLMarkup = require('../../_html_/offerCard.hbs');

/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * FIND STRUCTURE OF PRICE DETAILS IN readme.md
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 */

/**
 *
 * @param element
 */
const renderOfferCardBody = (offer: IOfferFromJSON, offerCounter: number, numberOfOffers: number) => {

    const cardElement = document.createElement('div');
    cardElement.id = `offer-id-${offer.ID}`;
    cardElement.classList.add(OFFER_CARD_WRAPPER);
    if ((offerCounter + 1) < numberOfOffers) {
        cardElement.classList.add('brix-spacing-200');
    }
    cardElement.innerHTML = HTMLMarkup();

    return cardElement;
};

/**
 * creates the offers dynamically depending on the JSON
 * @param mainElement
 * @param state
 */
export const renderOffers = (mainElement: HTMLElement, state, buttonClickAction, accordionOpenAction) => {

    // Offers without Bundle_Name shall not be rendered. (These are Additional_Contents without offer)
    const offers: IOfferFromJSON[] = state.currentOffers.filter((offer: IOfferFromJSON) => '' !== offer.Bundle_Name);
    const offersCount = offers.length;

    const isDefault: boolean = state.isDefault;

    // hide offers block
    // mainElement.style.display = 'none';

    // remove all Elements from DOM
    mainElement.innerHTML = '';

    // Loop all Offers
    for (let i = 0; i < offersCount; i++) {

        // Generate basic DIV for one card
        const offerElement = renderOfferCardBody(offers[i], i, offersCount);

        // append this DIV to the DOM
        mainElement.append(offerElement);

        // create Headlines above offer
        renderHeadlines(offerElement, i, offersCount, isDefault);

        // create Multidivider
        renderMultiDivider(offerElement, offers[i]);

        // create Benefit-List and Offer-Price
        renderBenefitList(offerElement, offers[i]);

        renderOfferPrice(offerElement, offers[i], buttonClickAction);

        // create Accordion
        renderAccordion(offerElement, offers[i], accordionOpenAction);

        // Headlines for columns
        renderPriceDetailHeadlines(offerElement);

        // 1 - 8 Price Compositions
        renderPriceCompositions(offerElement, offers[i]);

        // Total Discounts (The green line)
        renderTotalDiscounts(offerElement, offers[i]);

        // Baske Summary
        renderBasketSummary(offerElement, offers[i]);

        // show offers block
        const child = offerElement.getElementsByClassName('brix-card')[0];

        child.classList.add('giga-fade');

    }

};
